import EventEmitter from "./EventEmitter";

// Accessible switch
// from https://static.corp.google.com/ariablueprints/switch/switch.html
export default class Switch extends EventEmitter {
  constructor(container) {
    super();
    this.container = container;
    this.switch = this.container.querySelector("#switch");
    this.text = this.container.querySelector("p");
    this.switch.addEventListener(
      "click",
      (e) => {
        this.handleSwitchClick(e);
      },
      false
    );
    // this.switch.addEventListener(
    //   "keyup",
    //   (e) => {
    //     this.handleSwitchClick(e);
    //   },
    //   false
    // );
  }
  get state() {
    return this.switch.getAttribute("aria-checked") === "true";
  }

  show() {
    this.container.classList.remove("hide");
  }

  hide() {
    this.container.classList.add("hide");
  }

  handleSwitchClick(e) {
    if (e.type === "click" || (e.type === "keyup" && e.key === " ")) {
      if (this.switch.getAttribute("aria-checked") === "true") {
        this.switch.setAttribute("aria-checked", "false");
        this.text.classList.remove("active");
        this.raiseEvent("switch_change", [false]);
      } else {
        this.switch.setAttribute("aria-checked", "true");
        this.text.classList.add("active");
        this.raiseEvent("switch_change", [true]);
      }
    }
  }
}
